export const getTier = (score) => {
    if (score >= 95) return { label: "Red • G3", color: "#dc3545", textColor: "#fff" };
    if (score >= 90) return { label: "Red • G2", color: "#dc3545", textColor: "#fff" };
    if (score >= 85) return { label: "Red • G1", color: "#dc3545", textColor: "#fff" };
    
    if (score >= 80) return { label: "Black • G3", color: "#212529", textColor: "#fff" };
    if (score >= 75) return { label: "Black • G2", color: "#212529", textColor: "#fff" };
    if (score >= 70) return { label: "Black • G1", color: "#212529", textColor: "#fff" };
    
    if (score >= 65) return { label: "Purple • G3", color: "#6f42c1", textColor: "#fff" };
    if (score >= 60) return { label: "Purple • G2", color: "#6f42c1", textColor: "#fff" };
    if (score >= 55) return { label: "Purple • G1", color: "#6f42c1", textColor: "#fff" };
    
    if (score >= 50) return { label: "Blue • G3", color: "#0d6efd", textColor: "#fff" };
    if (score >= 45) return { label: "Blue • G2", color: "#0d6efd", textColor: "#fff" };
    if (score >= 40) return { label: "Blue • G1", color: "#0d6efd", textColor: "#fff" };
    
    if (score >= 30) return { label: "White • G3", color: "#e9ecef", textColor: "#212529" };
    if (score >= 20) return { label: "White • G2", color: "#e9ecef", textColor: "#212529" };
    return { label: "White • G1", color: "#e9ecef", textColor: "#212529" };
};

export const formatPeriod = (period) => {
    if (!period) return "";
    const [year, month] = period.split("-");
    const monthNames = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
    if (month && !isNaN(month)) {
        return `${monthNames[parseInt(month, 10)-1]}/${year}`;
    }
    return period;
};

export const getWorldCupStickerData = (rank, score) => {
    if (rank === 1) {
        return {
            title: "LENDA DE OURO",
            subtitle: "MITO DA COPA",
            footballRole: "Camisa 10 👑",
            bgGradient: "linear-gradient(135deg, #FFE066 0%, #F5B041 50%, #D35400 100%)",
            cardBg: "#F5B041",
            borderColor: "#FFE066",
            textColor: "#FFE066",
            foil: true,
            badge: "🏆",
            theme: "gold"
        };
    }
    if (rank === 2) {
        return {
            title: "CRAQUE DE PRATA",
            subtitle: "SUPER RARA",
            footballRole: "Artilheiro ⚡",
            bgGradient: "linear-gradient(135deg, #E2EBF0 0%, #CFD9DF 50%, #85929E 100%)",
            cardBg: "#BDC3C7",
            borderColor: "#FFFFFF",
            textColor: "#FFFFFF",
            foil: true,
            badge: "🥈",
            theme: "silver"
        };
    }
    if (rank === 3) {
        return {
            title: "PAREDÃO DE BRONZE",
            subtitle: "RARA",
            footballRole: "Xerife 🛡️",
            bgGradient: "linear-gradient(135deg, #FAD0C4 0%, #FF9A9E 50%, #B83B5E 100%)",
            cardBg: "#D35400",
            borderColor: "#FAD0C4",
            textColor: "#FF9A9E",
            foil: true,
            badge: "🥉",
            theme: "bronze"
        };
    }

    const generalPositions = [
        { role: "Meio-Campo 🏃", title: "TITULAR ABSOLUTO" },
        { role: "Ponta Veloz ⚡", title: "GARÇOM DO TIME" },
        { role: "Zagueiro Raça ⚔️", title: "XERIFE DA ZAGA" },
        { role: "Curinga 🃏", title: "12º JOGADOR" },
        { role: "Volante 🛡️", title: "MOTOR DO TIME" },
        { role: "Ponta de Lança 🎯", title: "FALSO 9" },
        { role: "Joia da Base 🌱", title: "REVELAÇÃO" }
    ];

    const pos = generalPositions[(rank - 4) % generalPositions.length] || { role: "Jogador 🏃", title: "DESTAQUE" };
    
    return {
        title: pos.title,
        subtitle: `Posição #${rank}`,
        footballRole: pos.role,
        bgGradient: "linear-gradient(135deg, #11998E 0%, #38EF7D 100%)",
        cardBg: "#11998E",
        borderColor: "#38EF7D",
        textColor: "#38EF7D",
        foil: false,
        badge: "⭐",
        theme: "normal"
    };
};

